import { hideModal } from '@/app/common/reducers/simpleModal';
import FalconCloseButton from '@/components/common/FalconCloseButton';
import { Modal } from '@/components/common/AppModal';
import { Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

const RemovedKeywordsModal = ({ volumeData }) => {
  const modalKey = useSelector(state => state.simpleModal);
  const dispatch = useDispatch();

  const titleMap = {
    DUPLICATE_KEYWORDS: 'کلمات تکراری حذف‌شده',
    SIMILARITY_KEYWORDS: 'کلمات مشابه حذف‌شده',
    NORMALIZED_KEYWORDS: 'کلمات نرمال‌سازی‌شده حذف‌شده'
  };

  const dataKeyMap = {
    DUPLICATE_KEYWORDS: 'remove_duplicates',
    SIMILARITY_KEYWORDS: 'remove_similarity',
    NORMALIZED_KEYWORDS: 'remove_normalized'
  };

  const currentDataKey = dataKeyMap[modalKey];
  const currentList = volumeData?.[currentDataKey] || [];
  const currentTitle = titleMap[modalKey];

  const showModal =
    modalKey === 'DUPLICATE_KEYWORDS' ||
    modalKey === 'SIMILARITY_KEYWORDS' ||
    modalKey === 'NORMALIZED_KEYWORDS';

  return (
    <Modal
      show={showModal}
      onHide={() => dispatch(hideModal())}
      size="lg"
      centered
    >
      <Modal.Header>
        <Modal.Title className="fs-0">
          {currentTitle || 'لیست کلمات'}
        </Modal.Title>
        <FalconCloseButton onClick={() => dispatch(hideModal())} />
      </Modal.Header>
      <Modal.Body>
        {currentList.length > 0 ? (
          <Form.Control
            // readOnly
            disabled
            rows={currentList.length > 10 ? 10 : currentList.length}
            as="textarea"
            value={currentList.map(keyword => `${keyword}`).join('\n')}
          />
        ) : (
          <p className="text-center text-muted mb-0">موردی یافت نشد.</p>
        )}
      </Modal.Body>
      <Modal.Footer className="p-2">
        <Button variant="secondary" onClick={() => dispatch(hideModal())}>
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemovedKeywordsModal;
